import { render } from "./CustomSelectOneFarm.vue?vue&type=template&id=6665d016"
import script from "./CustomSelectOneFarm.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneFarm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__